import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DataTestResultIconComponent } from './data-test-result-icon.component';

@NgModule({
  declarations: [DataTestResultIconComponent],
  imports: [CommonModule, MatTooltipModule],
  exports: [DataTestResultIconComponent],
})
export class DataTestResultIconModule {}
